export default "__VITE_ASSET__d49eb373__"